import React, { useState, useEffect } from "react";

const InstaEmbed = ({ profileId, accessToken }) => {
  const [latestPostUrl, setLatestPostUrl] = useState("");
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLatestPost = async () => {
      try {
        // Fetch the latest media from the Instagram Graph API
        const response = await fetch(
          `https://graph.instagram.com/${profileId}/media?fields=permalink&access_token=${accessToken}`,
        );
        const data = await response.json();

        if (data.data && data.data.length > 0) {
          setLatestPostUrl(data.data[0].permalink); // Get the latest post URL
        } else {
          setError("No posts found for this profile.");
        }
      } catch (err) {
        console.error("Error fetching Instagram post:", err);
        setError("Failed to fetch the latest Instagram post.");
      }
    };

    fetchLatestPost();
  }, [profileId, accessToken]);

  if (error) {
    return <p style={{ color: "red", textAlign: "center" }}>{error}</p>;
  }

  return latestPostUrl ? (
    <div
      style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}
    >
      <iframe
        src={`${latestPostUrl}embed`}
        width="328"
        height="400"
        frameBorder="0"
        scrolling="no"
        allowTransparency="true"
        title="Latest Instagram Post"
      ></iframe>
    </div>
  ) : (
    <p style={{ textAlign: "center" }}>Loading latest Instagram post...</p>
  );
};

export default InstaEmbed;
